import { InputBase, Divider, IconButton } from '@mui/material'
import { makeStyles, styled } from '@mui/styles'
import { useEffect, useState } from 'react'
import { useNoteApi } from '../../hooks/useNoteApi'
import { newThemeObject } from '../../newTheme'
import { useSelector } from '../../redux/hooks/useSelector'
import { Note } from '../../redux/reducers/note'
import CardWrapper from '../common/CardWrapper'
import React from 'react'

import { DeleteRounded as Delete } from '@mui/icons-material'
import { tokens } from '../../styles/tokens'

const useStyles = makeStyles(theme => ({
  noteWrapper: {
    gap: theme.spacing(1),
    display: 'grid',
    gridTemplateColumns: 'auto auto minmax(0, 1fr) auto',
    maxHeight: theme.spacing(35),
    overflowY: 'auto',
    padding: theme.spacing(2),
    alignItems: 'center',
  },
  noteText: {
    margin: 0,
    overflowWrap: 'break-word',
  },
  noteDate: {
    margin: 0,
    color: theme.palette.text.secondary,
  },
  divider: {
    gridColumn: '1 / -1',
  },
}))

interface NotesProps {
  clientId: number
  /** jen pro zakladani nove poznamky - v DB visi na portfoliu, uzivatelsky patri klientovi */
  portfolioId: number
}

const Notes = ({ clientId, portfolioId }: NotesProps) => {
  const notes = useSelector(state => state.noteState.notes)
  const classes = useStyles()
  const [newNoteContent, setNewNoteContent] = useState('')

  const { getClientNotes, createNote, deleteNote } = useNoteApi()

  // ctem per klient, ne per portfolio - jinak poznamky mizely pri prepnuti
  // portfolia a na agregatu (bez portfolioId) se nenacetly vubec
  useEffect(() => {
    if (clientId) {
      getClientNotes(clientId)
    }
  }, [clientId])

  const sendNote = () => {
    if (newNoteContent.trim()) {
      save()
      setNewNoteContent('')
    }
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      sendNote()
    }
  }

  const save = () => {
    let note: Note = {
      noteId: 0,
      date: new Date(),
      content: newNoteContent,
      portfolioId: portfolioId,
    }
    createNote(note)
  }

  const handleDelete = (noteId: number) => {
    deleteNote(noteId)
  }

  return (
    <CardWrapper>
      {/* pole pro novou poznamku patri nahoru - nejnovejsi poznamky jsou take nahore */}
      <NewNote
        placeholder="Začněte psát svou poznámku"
        value={newNoteContent}
        onChange={e => setNewNoteContent(e.target.value)}
        onKeyPress={handleKeyPress}
      />
      <div className={classes.noteWrapper}>
        {Array.isArray(notes) &&
          notes.map((note, index) => (
            <React.Fragment key={note.noteId}>
              <p className={classes.noteDate}>
                {`${new Date(note.date).getDate()}.${new Date(note.date).getMonth() + 1}.${new Date(
                  note.date
                ).getFullYear()}`}
              </p>

              <p className={classes.noteDate}>{`${new Date(note.date).getHours()}:${new Date(
                note.date
              ).getMinutes()}`}</p>
              <p className={classes.noteText}>{note.content}</p>
              <IconButton onClick={() => handleDelete(note.noteId)} size="small">
                <Delete />
              </IconButton>
              {index !== notes.length - 1 && <Divider className={classes.divider} />}
            </React.Fragment>
          ))}
      </div>
    </CardWrapper>
  )
}

export default Notes

const NewNote = styled(InputBase)(({ theme }) => ({
  width: '100%',

  '& .MuiInputBase-input': {
    borderRadius: newThemeObject.roundness.basic,
    position: 'relative',
    backgroundColor: newThemeObject.palette.background.lightGray,
    borderColor: theme.palette.mode === 'light' ? tokens.color.neutral[200] : '#2D3843',
    fontSize: '0.7rem',
    width: '100%',
    padding: '10px 12px',
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
  },
}))
